import React, { createContext, useContext, useMemo } from 'react';
import { Provider } from 'react-redux';

import configureStore from '../store/tableViewStore';
import TableViewContainer from '../containers/TableViewContainer';

export const TableViewContext = createContext({});

export const useTableViewContext = () => useContext(TableViewContext);

// See documentation for https://github.com/reactjs/react-redux.
// This is how you get props from the Rails view into the redux store.
// This code here binds your smart component to the redux store.
const TableViewApp = ({ hiddenFilterParams = [], ...props }) => {
  const store = useMemo(() => configureStore(props), []);

  return (
    <Provider store={store}>
      <TableViewContext.Provider value={{ hiddenFilterParams }}>
        <TableViewContainer />
      </TableViewContext.Provider>
    </Provider>
  );
};

export default TableViewApp;
